<script>
    import {login, sendPassword} from "./requests";
    import user from "./stores/user";
    import members from './stores/members';
    import groups from "./stores/groups";
    import success from "./stores/success";

    let view = 1; // 1 = login, 2 = password reminder, 3 = signup
    let username = "";
    let password = "";
    let email = "";

    let error = "";
    let successRemindPassword = false;

    const onShowLogin = () => {
        view = 1;
    }

    const loginHandler = async () => {
        error = "";
        const [err, res] = await login(username, password);

        if (err) {
            error = err;
            //alert('error ' + err)
            return;
        }

        res.user.app_name = res.user.name ? res.user.name : res.user.lastname;
        user.set(res.user);
        $members.list = res.members;
        $groups.list = res.groups;
        $groups.list.map(group => {
            group.id = parseInt(group.id);
            group.type = parseInt(group.type);
        });

        success.show('Καλώς ήλθατε ' + $user.app_name);
    }

    const onShowPasswordRemind = () => {
        view = 2;
        successRemindPassword = false;
    }

    const remindPassword = async () => {
        successRemindPassword = false;
        error = "";
        const [err, res] = await sendPassword(username);

        if (err) {
            error = err;
            return;
        }

        if (res.success) {
            successRemindPassword = true;
        }
    }
</script>

<div class="login-overlay">
    <div class="login-inner">
        <div class="login-logo">
            <img src="/assets/images/logo.png" alt="Sendsms.gr logo">
        </div>
        <div class="panel login-panel">
            {#if view === 1 }
                <div class="panel-heading">
                    Είσοδος Χρήστη
                </div>
                <div class="panel-body">
                    <form on:submit|preventDefault="{loginHandler}">
                        <div class="form-group">
                            <input bind:value="{ username }" type="text" class="form-control" placeholder="όνομα χρήστη"
                                   required>
                        </div>
                        <div class="form-group">
                            <input bind:value="{ password }" type="password" class="form-control" placeholder="κωδικός"
                                   required>
                        </div>
                        <p class="text-center">
                            <a href="#" on:click|preventDefault="{ onShowPasswordRemind }">Ξέχασα τον κωδικό μου</a>
                        </p>
                        {#if (error)}
                            <div class="alert alert-danger">{error}</div>
                        {/if}
                        <button class="btn btn-primary btn-block">Είσοδος</button>
                    </form>
                </div>
            {:else}
                <div class="panel-heading">
                    Υπενθύμιση κωδικού
                </div>
                <div class="panel-body">
                    {#if !successRemindPassword}
                        <form on:submit|preventDefault="{remindPassword}">
                            <p class="mrg-t-none">Πληκτρολογήστε το όνομα χρήστη ή το email του λογαριασμού σας</p>
                            <div class="form-group">
                                <input bind:value="{ username }" type="text" class="form-control" placeholder="όνομα χρήστη ή email"
                                       required>
                            </div>
                            {#if error}
                                <div class="alert alert-danger">{error}</div>
                            {/if}
                            <button class="btn btn-primary btn-block">Αποστολή κωδικού</button>
                        </form>
                    {:else}
                        <p class="mrg-t-none">
                            Τα στοιχεία του λογαριασμού σας έχου αποσταλεί στο email σας.
                        </p>
                    {/if}
                    <hr>
                    <div class="text-center">
                        <a href="#" on:click|preventDefault="{ onShowLogin }">Επιστροφή στην είσοδο</a>
                    </div>
                </div>
            {/if}
        </div>
    </div>
</div>

<style>
    .login-overlay {
        position: fixed;
        top: 0;
        bottom: 0;
        lefT: 0;
        right: 0;
        background: #f1f2f7;
        z-index: 2000;
    }

    .login-inner {
        position: absolute;
        /*min-width: 360px;*/
        width: 80%;
        max-width: 300px;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
    }
    .login-inner.big {
        width: 100%;
        max-width: 100%;
    }

    .login-panel {
        /*width:100%;*/
    }

    .login-logo {
        margin-bottom: 10px;
    }

    .login-logo img {
        width: 100%;
    }
</style>